import { cn } from "@/lib/utils";

export default function Divider(props: { className?: string }) {
  return (
    <hr
      className={cn("mx-2 h-3 w-px bg-[#A6A6A6] lg:mx-3", props.className)}
    />
  );
}
